export default {
	async initializeData({ state }) {
		try {
			const response = await fetch('/common/selected_data.json');
			state.games = await response.json();
		} catch (error) {
			console.error('Error loading JSON data:', error);
		}
	}
}